import { EXCISE_PRODUCT_TYPE } from "./countryProductUtils";

export const PRE_FINANCE_PERIOD_MONTHLY = 1;
export const PRE_FINANCE_PERIOD_QUARTERLY = 2;

export const EXCISE_QUARTER_OPTIONS = [
  { value: 1, label: "Q1" },
  { value: 2, label: "Q2" },
  { value: 3, label: "Q3" },
  { value: 4, label: "Q4" },
];

export const getQuarterBounds = (quarter) => {
  switch (Number(quarter)) {
    case 1:
      return { startMonth: 1, endMonth: 3 };
    case 2:
      return { startMonth: 4, endMonth: 6 };
    case 3:
      return { startMonth: 7, endMonth: 9 };
    case 4:
      return { startMonth: 10, endMonth: 12 };
    default:
      return { startMonth: 1, endMonth: 3 };
  }
};

export const getQuarterFromMonth = (month) => Math.floor((Number(month) - 1) / 3) + 1;

export const isQuarterElapsed = (year, quarter, now = new Date()) => {
  const { endMonth } = getQuarterBounds(quarter);
  const periodEnd = new Date(Number(year), endMonth, 0);
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  return today > periodEnd;
};

export const getLatestElapsedQuarter = (now = new Date()) => {
  const year = now.getFullYear();
  const quarter = getQuarterFromMonth(now.getMonth() + 1);

  if (isQuarterElapsed(year, quarter, now)) {
    return { year, quarter };
  }

  if (quarter === 1) {
    return { year: year - 1, quarter: 4 };
  }

  return { year, quarter: quarter - 1 };
};

export const usesExciseQuarterPicker = (agreements = [], countryId = 0) => {
  const exciseAgreements = agreements.filter(
    (agreement) =>
      Number(agreement.productType) === EXCISE_PRODUCT_TYPE && Number(agreement.vf) > 0
  );
  const relevantAgreements = Number(countryId)
    ? exciseAgreements.filter((agreement) => Number(agreement.country) === Number(countryId))
    : exciseAgreements;

  return relevantAgreements.some(
    (agreement) => Number(agreement.preFinancePeriodType) === PRE_FINANCE_PERIOD_QUARTERLY
  );
};
